export const searchUILabels = {
  product_type: {
    label: 'Product Type',
  },
  'options.color': {
    label: 'Color',
  },
  'meta.gwm.fits_cup_holder': {
    label: 'Cupholder Friendly',
    values: {
      true: 'Yes',
      false: 'No',
    },
  },
  'named_tags.Capacity': {
    label: 'Size',
  },
  'named_tags.Size': {
    label: 'Size',
  },
  'named_tags.Bottle Style': {
    label: 'Bottle Style',
  },
  'named_tags.Lid Style': {
    label: 'Lid Style',
  },
  price: {
    label: 'Price',
    prefix: '$',
  },
};
